// Mock data for PM demo - matches their real project types
export const mockProjects = [
  {
    id: 1,
    jobNumber: 'J2024-087',
    name: 'Noblesville High School Cameras PLTW',
    client: 'Noblesville Schools',
    pm: 'Matt',
    pmColor: '#2196f3', // Matt's blue
    status: 'Active',
    budgetHours: 80,
    actualHours: 52,
    progress: 65,
    startDate: '2024-09-15',
    endDate: '2024-10-30',
    hasLift: true,
    liftHeight: '35 ft',
    liftProvider: 'Customer',
    lastNote: 'Waiting on change order approval',
    files: [
      {
        id: 'f1',
        name: 'Installation Plans v3.pdf',
        isPinned: true,
        category: 'Plans',
        version: 3,
        uploadedBy: 'Engineering',
        uploadedAt: '2024-08-10',
        visitNumber: 3,
        size: '4.2 MB'
      },
      {
        id: 'f2',
        name: 'Change Order #2.pdf',
        isPinned: true,
        category: 'Change Order',
        version: 2,
        uploadedBy: 'Mark',
        uploadedAt: '2024-10-15',
        visitNumber: 45,
        size: '1.8 MB',
        isNew: true
      },
      // Regular files (would be buried in Jobber)
      ...Array.from({ length: 85 }, (_, i) => ({
        id: `visit-${i + 3}`,
        name: `Visit ${i + 3} Notes`,
        isPinned: false,
        category: 'Notes',
        uploadedBy: 'Field Tech',
        uploadedAt: new Date(Date.now() - (85 - i) * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        visitNumber: i + 3,
        size: '12 KB'
      }))
    ]
  },
  {
    id: 2,
    jobNumber: 'J2024-091',
    name: "Fisher's Harney Microphone Add",
    client: "Fisher's",
    pm: 'Clayton',
    pmColor: '#4caf50', // Clayton's green
    status: 'Active',
    budgetHours: 8,
    actualHours: 12,
    progress: 85,
    startDate: '2024-09-20',
    endDate: '2024-10-04',
    hasLift: false,
    lastNote: 'Testing final audio levels - minor delay'
  },
  {
    id: 3,
    jobNumber: 'J2024-045',
    name: 'HSE School District - 7 Schools',
    client: 'HSE',
    pm: 'Brandon',
    pmColor: '#f44336', // Brandon's red
    status: 'Active',
    budgetHours: 2400,
    actualHours: 847,
    progress: 35,
    startDate: '2024-01-15',
    endDate: '2026-01-15',
    hasLift: true,
    liftHeight: '40 ft',
    liftProvider: 'Blades AV',
    lastNote: 'Phase 2 starting next week',
    duration: '2 years',
    isLargeProject: true,
    milestones: [
      { id: 1, name: 'Phase 1: Elementary Schools (3)', budgetHours: 720, actualHours: 580, status: 'Completed', progress: 100, completedDate: '2024-07-15' },
      { id: 2, name: 'Phase 2: Middle Schools (2)', budgetHours: 800, actualHours: 267, status: 'Active', progress: 45, expectedCompletion: '2024-12-15' },
      { id: 3, name: 'Phase 3: High School (2)', budgetHours: 880, actualHours: 0, status: 'Upcoming', progress: 0, expectedStart: '2025-01-15' }
    ],
    currentPhase: 'Phase 2: Middle Schools'
  },
  {
    id: 4,
    jobNumber: 'J2024-089',
    name: 'Westfield Middle School Gym',
    client: 'Westfield Schools',
    pm: 'Matt',
    pmColor: '#2196f3',
    status: 'Active',
    budgetHours: 120,
    actualHours: 108,
    progress: 90,
    startDate: '2024-09-01',
    endDate: '2024-10-31',
    hasLift: true,
    liftHeight: '45 ft',
    liftProvider: 'Customer',
    lastNote: 'URGENT: Approaching budget limit - need approval for additional hours'
  },
  {
    id: 5,
    jobNumber: 'J2024-093',
    name: 'Zionsville Town Hall AV Upgrade',
    client: 'Town of Zionsville',
    pm: 'Clayton',
    pmColor: '#4caf50',
    status: 'Planning',
    budgetHours: 60,
    actualHours: 0,
    progress: 0,
    startDate: '2024-11-01',
    endDate: '2024-11-30'
  }
];

// Mock installers for schedule view
export const mockInstallers = [
  {
    id: 1,
    name: 'Brandon',
    color: '#f44336',
    maxHours: 40
  },
  {
    id: 2,
    name: 'Matt',
    color: '#2196f3',
    maxHours: 40
  },
  {
    id: 3,
    name: 'Clayton',
    color: '#4caf50',
    maxHours: 40
  },
  {
    id: 4,
    name: 'Mike',
    color: '#9c27b0',
    maxHours: 40
  },
  {
    id: 5,
    name: 'Steve',
    color: '#ff9800',
    maxHours: 40
  },
  {
    id: 6,
    name: 'Tom',
    color: '#795548',
    maxHours: 40
  },
  {
    id: 7,
    name: 'Chris',
    color: '#607d8b',
    maxHours: 40
  },
  {
    id: 8,
    name: 'Dave',
    color: '#e91e63',
    maxHours: 40
  }
];

// Mock weekly schedule
export const mockSchedule = {
  'Brandon': {
    'Mon': [{ job: 'J2024-045', hours: 8, client: 'HSE' }],
    'Tue': [{ job: 'J2024-045', hours: 8, client: 'HSE' }],
    'Wed': [{ job: 'J2024-045', hours: 8, client: 'HSE' }],
    'Thu': [{ job: 'J2024-045', hours: 8, client: 'HSE' }],
    'Fri': [{ job: 'J2024-045', hours: 6, client: 'HSE' }]
  },
  'Matt': {
    'Mon': [{ job: 'J2024-087', hours: 8, client: 'Noblesville' }],
    'Tue': [{ job: 'J2024-089', hours: 8, client: 'Westfield' }],
    'Wed': [{ job: 'J2024-087', hours: 4, client: 'Noblesville' }, { job: 'J2024-089', hours: 4, client: 'Westfield' }],
    'Thu': [{ job: 'J2024-089', hours: 8, client: 'Westfield' }],
    'Fri': [{ job: 'J2024-087', hours: 8, client: 'Noblesville' }]
  },
  'Clayton': {
    'Mon': [],
    'Tue': [],
    'Wed': [{ job: 'J2024-093', hours: 4, client: 'Zionsville' }],
    'Thu': [{ job: 'J2024-093', hours: 8, client: 'Zionsville' }],
    'Fri': [{ job: 'J2024-091', hours: 3, client: "Fisher's" }]
  },
  'Mike': {
    'Mon': [{ job: 'J2024-087', hours: 8, client: 'Noblesville' }],
    'Tue': [{ job: 'J2024-087', hours: 8, client: 'Noblesville' }],
    'Wed': [{ job: 'J2024-089', hours: 8, client: 'Westfield' }],
    'Thu': [{ job: 'J2024-089', hours: 8, client: 'Westfield' }],
    'Fri': [{ job: 'J2024-087', hours: 8, client: 'Noblesville' }]
  },
  'Steve': {
    'Mon': [{ job: 'J2024-045', hours: 8, client: 'HSE' }],
    'Tue': [{ job: 'J2024-045', hours: 8, client: 'HSE' }],
    'Wed': [],
    'Thu': [],
    'Fri': []
  },
  'Tom': {
    'Mon': [],
    'Tue': [],
    'Wed': [],
    'Thu': [],
    'Fri': []
  },
  'Chris': {
    'Mon': [{ job: 'J2024-089', hours: 8, client: 'Westfield' }],
    'Tue': [],
    'Wed': [],
    'Thu': [{ job: 'J2024-087', hours: 8, client: 'Noblesville' }],
    'Fri': [{ job: 'J2024-087', hours: 8, client: 'Noblesville' }]
  },
  'Dave': {
    'Mon': [],
    'Tue': [{ job: 'J2024-045', hours: 4, client: 'HSE' }],
    'Wed': [{ job: 'J2024-045', hours: 4, client: 'HSE' }],
    'Thu': [],
    'Fri': []
  }
};

// Project templates
export const projectTemplates = [
  {
    id: 'school-install',
    name: 'School Installation',
    description: 'Standard school AV installation',
    defaultBudgetHours: 80,
    requiresLift: true,
    defaultLiftHeight: '35 ft',
    tasks: [
      'Site survey',
      'Equipment delivery',
      'Mounting and installation',
      'Cable runs',
      'System configuration',
      'Testing and commissioning',
      'Training',
      'Documentation handoff'
    ]
  },
  {
    id: 'quick-delivery',
    name: 'Quick Delivery',
    description: 'Simple equipment delivery and setup',
    defaultBudgetHours: 3,
    requiresLift: false,
    tasks: [
      'Equipment pickup',
      'Delivery',
      'Basic setup',
      'Customer sign-off'
    ]
  },
  {
    id: 'multi-site',
    name: 'Multi-Site Deployment',
    description: 'Large scale multi-location project',
    defaultBudgetHours: 2000,
    requiresLift: true,
    defaultLiftHeight: '40 ft',
    tasks: [
      'Project kickoff',
      'Site surveys (all locations)',
      'Equipment staging',
      'Phase 1 installations',
      'Phase 2 installations',
      'System integration',
      'Final testing',
      'Project closeout'
    ]
  }
];

// Historical project data for the last 6 months (completed projects)
export const historicalProjects = [
  // April 2024
  {
    id: 'h1',
    jobNumber: 'J2024-023',
    name: 'Carmel Elementary Classroom AV',
    client: 'Carmel Schools',
    pm: 'Matt',
    pmColor: '#2196f3',
    status: 'Completed',
    budgetHours: 24,
    actualHours: 22,
    progress: 100,
    startDate: '2024-04-08',
    endDate: '2024-04-12',
    completedDate: '2024-04-11',
    monthYear: 'April 2024',
    efficiency: 0.92, // Under budget
    customerSatisfaction: 5,
    notes: 'Completed ahead of schedule, customer very satisfied'
  },
  {
    id: 'h2',
    jobNumber: 'J2024-019',
    name: 'Fishers City Hall Boardroom',
    client: 'City of Fishers',
    pm: 'Clayton',
    pmColor: '#4caf50',
    status: 'Completed',
    budgetHours: 16,
    actualHours: 20,
    progress: 100,
    startDate: '2024-04-15',
    endDate: '2024-04-18',
    completedDate: '2024-04-19',
    monthYear: 'April 2024',
    efficiency: 1.25, // Over budget
    customerSatisfaction: 4,
    notes: 'Additional wiring required, slight delay'
  },

  // May 2024
  {
    id: 'h3',
    jobNumber: 'J2024-031',
    name: 'Westfield Library Meeting Rooms',
    client: 'Westfield Library',
    pm: 'Brandon',
    pmColor: '#f44336',
    status: 'Completed',
    budgetHours: 32,
    actualHours: 28,
    progress: 100,
    startDate: '2024-05-06',
    endDate: '2024-05-10',
    completedDate: '2024-05-09',
    monthYear: 'May 2024',
    efficiency: 0.88,
    customerSatisfaction: 5,
    notes: 'Excellent execution, came in under budget'
  },
  {
    id: 'h4',
    jobNumber: 'J2024-034',
    name: 'Noblesville Fire Station',
    client: 'Noblesville Fire Dept',
    pm: 'Matt',
    pmColor: '#2196f3',
    status: 'Completed',
    budgetHours: 12,
    actualHours: 12,
    progress: 100,
    startDate: '2024-05-20',
    endDate: '2024-05-22',
    completedDate: '2024-05-22',
    monthYear: 'May 2024',
    efficiency: 1.0,
    customerSatisfaction: 5,
    notes: 'Perfect execution, on time and on budget'
  },

  // June 2024
  {
    id: 'h5',
    jobNumber: 'J2024-041',
    name: 'Hamilton County Office',
    client: 'Hamilton County',
    pm: 'Clayton',
    pmColor: '#4caf50',
    status: 'Completed',
    budgetHours: 40,
    actualHours: 45,
    progress: 100,
    startDate: '2024-06-03',
    endDate: '2024-06-07',
    completedDate: '2024-06-10',
    monthYear: 'June 2024',
    efficiency: 1.13,
    customerSatisfaction: 4,
    notes: 'Complex cable routing took longer than expected'
  },
  {
    id: 'h6',
    jobNumber: 'J2024-038',
    name: 'Zionsville Community Center',
    client: 'Town of Zionsville',
    pm: 'Brandon',
    pmColor: '#f44336',
    status: 'Completed',
    budgetHours: 28,
    actualHours: 25,
    progress: 100,
    startDate: '2024-06-17',
    endDate: '2024-06-20',
    completedDate: '2024-06-19',
    monthYear: 'June 2024',
    efficiency: 0.89,
    customerSatisfaction: 5,
    notes: 'Smooth installation, client loved the result'
  },

  // July 2024
  {
    id: 'h7',
    jobNumber: 'J2024-048',
    name: 'Carmel High School Auditorium Upgrade',
    client: 'Carmel Schools',
    pm: 'Matt',
    pmColor: '#2196f3',
    status: 'Completed',
    budgetHours: 120,
    actualHours: 115,
    progress: 100,
    startDate: '2024-07-08',
    endDate: '2024-07-19',
    completedDate: '2024-07-18',
    monthYear: 'July 2024',
    efficiency: 0.96,
    customerSatisfaction: 5,
    notes: 'Major project completed successfully, great teamwork'
  },
  {
    id: 'h8',
    jobNumber: 'J2024-052',
    name: 'Fishers Police Training Room',
    client: 'Fishers Police Dept',
    pm: 'Clayton',
    pmColor: '#4caf50',
    status: 'Completed',
    budgetHours: 18,
    actualHours: 22,
    progress: 100,
    startDate: '2024-07-22',
    endDate: '2024-07-25',
    completedDate: '2024-07-26',
    monthYear: 'July 2024',
    efficiency: 1.22,
    customerSatisfaction: 4,
    notes: 'Security requirements added extra complexity'
  },

  // August 2024
  {
    id: 'h9',
    jobNumber: 'J2024-059',
    name: 'Westfield Middle School Science Labs',
    client: 'Westfield Schools',
    pm: 'Brandon',
    pmColor: '#f44336',
    status: 'Completed',
    budgetHours: 64,
    actualHours: 58,
    progress: 100,
    startDate: '2024-08-05',
    endDate: '2024-08-12',
    completedDate: '2024-08-11',
    monthYear: 'August 2024',
    efficiency: 0.91,
    customerSatisfaction: 5,
    notes: 'Summer installation window utilized perfectly'
  },
  {
    id: 'h10',
    jobNumber: 'J2024-063',
    name: 'Noblesville City Council Chambers',
    client: 'City of Noblesville',
    pm: 'Matt',
    pmColor: '#2196f3',
    status: 'Completed',
    budgetHours: 36,
    actualHours: 38,
    progress: 100,
    startDate: '2024-08-19',
    endDate: '2024-08-23',
    completedDate: '2024-08-23',
    monthYear: 'August 2024',
    efficiency: 1.06,
    customerSatisfaction: 5,
    notes: 'Minor adjustments for optimal acoustics'
  },

  // September 2024
  {
    id: 'h11',
    jobNumber: 'J2024-071',
    name: 'Hamilton SE High School Theater',
    client: 'HSE Schools',
    pm: 'Clayton',
    pmColor: '#4caf50',
    status: 'Completed',
    budgetHours: 88,
    actualHours: 82,
    progress: 100,
    startDate: '2024-09-02',
    endDate: '2024-09-13',
    completedDate: '2024-09-12',
    monthYear: 'September 2024',
    efficiency: 0.93,
    customerSatisfaction: 5,
    notes: 'Excellent coordination with theater department'
  },
  {
    id: 'h12',
    jobNumber: 'J2024-074',
    name: 'Carmel Corporate Training Center',
    client: 'Carmel Clay Schools',
    pm: 'Brandon',
    pmColor: '#f44336',
    status: 'Completed',
    budgetHours: 44,
    actualHours: 46,
    progress: 100,
    startDate: '2024-09-16',
    endDate: '2024-09-20',
    completedDate: '2024-09-20',
    monthYear: 'September 2024',
    efficiency: 1.05,
    customerSatisfaction: 4,
    notes: 'Last-minute presentation equipment added'
  }
];

// Monthly performance metrics for historical reporting
export const monthlyMetrics = [
  {
    month: 'April 2024',
    projectsCompleted: 2,
    totalBudgetHours: 40,
    totalActualHours: 42,
    averageEfficiency: 1.09,
    averageCustomerSatisfaction: 4.5,
    revenue: 3360, // Assuming $80/hour average
    onTimeCompletion: 50 // 1 of 2 projects
  },
  {
    month: 'May 2024',
    projectsCompleted: 2,
    totalBudgetHours: 44,
    totalActualHours: 40,
    averageEfficiency: 0.94,
    averageCustomerSatisfaction: 5.0,
    revenue: 3520,
    onTimeCompletion: 100 // 2 of 2 projects
  },
  {
    month: 'June 2024',
    projectsCompleted: 2,
    totalBudgetHours: 68,
    totalActualHours: 70,
    averageEfficiency: 1.01,
    averageCustomerSatisfaction: 4.5,
    revenue: 5440,
    onTimeCompletion: 50 // 1 of 2 projects
  },
  {
    month: 'July 2024',
    projectsCompleted: 2,
    totalBudgetHours: 138,
    totalActualHours: 137,
    averageEfficiency: 1.09,
    averageCustomerSatisfaction: 4.5,
    revenue: 11040,
    onTimeCompletion: 50 // 1 of 2 projects
  },
  {
    month: 'August 2024',
    projectsCompleted: 2,
    totalBudgetHours: 100,
    totalActualHours: 96,
    averageEfficiency: 0.99,
    averageCustomerSatisfaction: 5.0,
    revenue: 8000,
    onTimeCompletion: 100 // 2 of 2 projects
  },
  {
    month: 'September 2024',
    projectsCompleted: 2,
    totalBudgetHours: 132,
    totalActualHours: 128,
    averageEfficiency: 0.99,
    averageCustomerSatisfaction: 4.5,
    revenue: 10560,
    onTimeCompletion: 100 // 2 of 2 projects
  }
];